import React, { PureComponent } from 'react'
import PropTypes from 'prop-types';

import { firebase, authUI } from '../../utils/firebase';

class FirebaseAuth extends PureComponent {
    componentDidMount() {
        const uiConfig = {
            callbacks: {
                signInSuccess: (user) => {
                    if (this.props.onSignIn) {
                        this.props.onSignIn(user);
                    }
                    return false;
                },
            },
            signInOptions: [
                firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                {
                    provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
                    scopes: [
                        'public_profile',
                        'email',
                    ],
                },
            ],
        };

        authUI.start('#firebaseui-auth', uiConfig);
    }

    componentWillUnmount() {
        authUI.reset();
    }

    render() {
        return <div id="firebaseui-auth" />;
    }
}

FirebaseAuth.propTypes = {
    onSignIn: PropTypes.func.isRequired,
};

export default FirebaseAuth;



// WEBPACK FOOTER //
// ./src/components/widgets/FirebaseAuth.js